package com.eladfinish.bible.contest.screens.search

import com.eladfinish.bible.contest.common.usecases.GetHighlightedVerseMarkupRangeUseCase
import com.eladfinish.bible.contest.common.usecases.MakeOtiotPasukSmallerUseCase
import com.eladfinish.bible.contest.screens.search.ai.GetAiSearchSuggestionUseCase
import com.eladfinish.bible.contest.screens.search.usecases.BuildLocalSearchRequestUseCase
import com.eladfinish.bible.contest.screens.search.usecases.BuildSearchTerminationMessageUseCase
import com.eladfinish.bible.contest.screens.search.usecases.ExecuteLocalSearchUseCase
import com.eladfinish.bible.contest.screens.search.usecases.ExtractSpecialSearchQueryUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetPostSearchSuggestionsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetSearchFactsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetSearchedChaptersUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetSpecialSignsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetTextToCopyFromTextFieldUseCase
import com.eladfinish.bible.contest.screens.search.usecases.IncreaseNumberOfSearchesUseCase
import com.eladfinish.bible.contest.screens.search.usecases.InsertTextAtCursorUseCase
import com.eladfinish.bible.contest.screens.search.usecases.LinkToExamplesUseCase
import com.eladfinish.bible.contest.screens.search.usecases.NavigateToAdjacentChapterUseCase
import com.eladfinish.bible.contest.screens.search.usecases.SaveSearchResultsToFileUseCase
import com.eladfinish.bible.contest.screens.search.usecases.date.SearchDateUseCase
import com.eladfinish.bible.contest.screens.search.usecases.engine.PrepareLocalSearchRequestUseCase
import com.eladfinish.bible.contest.screens.search.usecases.facts.ExecuteSpecialSearchUseCase
import com.eladfinish.bible.contest.screens.search.usecases.number.SearchNumberUseCase
import com.eladfinish.bible.contest.screens.search.usecases.root.SearchRootUseCase
import com.eladfinish.bible.contest.screens.search.usecases.searchSuggestion.BuildSearchSuggestionUseCase

interface SearchUseCaseProvider {
    val getSpecialSignsUseCase: GetSpecialSignsUseCase
    val linkToExamplesUseCase: LinkToExamplesUseCase
    val prepareLocalSearchRequestUseCase: PrepareLocalSearchRequestUseCase
    val executeLocalSearchUseCase: ExecuteLocalSearchUseCase
    val getSearchedChaptersUseCase: GetSearchedChaptersUseCase
    val searchNumberUseCase: SearchNumberUseCase
    val searchRootUseCase: SearchRootUseCase
    val searchDateUseCase: SearchDateUseCase
    val extractSpecialSearchQueryUseCase: ExtractSpecialSearchQueryUseCase
    val buildLocalSearchRequestUseCase: BuildLocalSearchRequestUseCase
    val buildSearchTerminationMessageUseCase: BuildSearchTerminationMessageUseCase
    val getHighlightedVerseMarkupRangeUseCase: GetHighlightedVerseMarkupRangeUseCase
    val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase
    val navigateToAdjacentChapterUseCase: NavigateToAdjacentChapterUseCase
    val getSearchFactsUseCase: GetSearchFactsUseCase
    val executeSpecialSearchUseCase: ExecuteSpecialSearchUseCase
    val getAiSearchSuggestionUseCase: GetAiSearchSuggestionUseCase
    val insertTextAtCursorUseCase: InsertTextAtCursorUseCase
    val getTextToCopyFromTextFieldUseCase: GetTextToCopyFromTextFieldUseCase
    val saveSearchResultsToFileUseCase: SaveSearchResultsToFileUseCase
    val getPostSearchSuggestionsUseCase: GetPostSearchSuggestionsUseCase
    val buildSearchSuggestionUseCase: BuildSearchSuggestionUseCase
    val increaseNumberOfSearchesUseCase: IncreaseNumberOfSearchesUseCase
}

class SearchUseCaseProviderImpl(
    override val getSpecialSignsUseCase: GetSpecialSignsUseCase,
    override val linkToExamplesUseCase: LinkToExamplesUseCase,
    override val prepareLocalSearchRequestUseCase: PrepareLocalSearchRequestUseCase,
    override val executeLocalSearchUseCase: ExecuteLocalSearchUseCase,
    override val getSearchedChaptersUseCase: GetSearchedChaptersUseCase,
    override val searchNumberUseCase: SearchNumberUseCase,
    override val searchRootUseCase: SearchRootUseCase,
    override val searchDateUseCase: SearchDateUseCase,
    override val extractSpecialSearchQueryUseCase: ExtractSpecialSearchQueryUseCase,
    override val buildLocalSearchRequestUseCase: BuildLocalSearchRequestUseCase,
    override val buildSearchTerminationMessageUseCase: BuildSearchTerminationMessageUseCase,
    override val getHighlightedVerseMarkupRangeUseCase: GetHighlightedVerseMarkupRangeUseCase,
    override val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase,
    override val navigateToAdjacentChapterUseCase: NavigateToAdjacentChapterUseCase,
    override val getSearchFactsUseCase: GetSearchFactsUseCase,
    override val executeSpecialSearchUseCase: ExecuteSpecialSearchUseCase,
    override val getAiSearchSuggestionUseCase: GetAiSearchSuggestionUseCase,
    override val insertTextAtCursorUseCase: InsertTextAtCursorUseCase,
    override val getTextToCopyFromTextFieldUseCase: GetTextToCopyFromTextFieldUseCase,
    override val saveSearchResultsToFileUseCase: SaveSearchResultsToFileUseCase,
    override val getPostSearchSuggestionsUseCase: GetPostSearchSuggestionsUseCase,
    override val buildSearchSuggestionUseCase: BuildSearchSuggestionUseCase,
    override val increaseNumberOfSearchesUseCase: IncreaseNumberOfSearchesUseCase,
) : SearchUseCaseProvider
